import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Shield, Mail, MapPin } from 'lucide-react';

const Privacy = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      {/* Hero Section */}
      <section className="relative pt-32 pb-12 bg-gradient-to-br from-gray-900 to-gray-800 dark:from-black dark:to-gray-900 text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <Shield className="w-16 h-16 mx-auto mb-6 text-[#F05627]" />
            <h1 className="text-4xl md:text-5xl font-bold mb-4">{t('privacy.title')}</h1>
            <p className="text-lg text-gray-300">{t('privacy.subtitle')}</p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-8 md:p-12">
            <div className="prose prose-lg max-w-none">
              {/* Section 1 */}
              <div className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">{t('privacy.section1.title')}</h2>
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">{t('privacy.section1.content')}</p>
                <div className="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg">
                  <p className="font-semibold text-gray-900 dark:text-white">Reaksiyon Araştırma</p>
                  <div className="flex items-center gap-2 mt-2 text-gray-600 dark:text-gray-300">
                    <MapPin className="w-4 h-4" />
                    <span className="text-sm">Bahçeler Sokak 19/1 Kat:4, Mecidiyeköy - Şişli - İstanbul</span>
                  </div>
                  <div className="flex items-center gap-2 mt-2 text-gray-600 dark:text-gray-300">
                    <Mail className="w-4 h-4" />
                    <a href="mailto:info@reaksiyonarastirma.com" className="text-sm hover:text-[#F05627]">info@reaksiyonarastirma.com</a>
                  </div>
                </div>
              </div>

              {/* Section 2 */}
              <div className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">{t('privacy.section2.title')}</h2>
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-3">{t('privacy.section2.content')}</p>
                <ul className="list-disc pl-6 space-y-2 text-gray-700 dark:text-gray-300">
                  {t('privacy.section2.items').map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>

              {/* Section 3 */}
              <div className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">{t('privacy.section3.title')}</h2>
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-3">{t('privacy.section3.content')}</p>
                <ul className="list-disc pl-6 space-y-2 text-gray-700 dark:text-gray-300">
                  {t('privacy.section3.items').map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>

              {/* Section 4 */}
              <div className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">{t('privacy.section4.title')}</h2>
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-3">{t('privacy.section4.content')}</p>
                <ul className="list-disc pl-6 space-y-2 text-gray-700 dark:text-gray-300">
                  {t('privacy.section4.items').map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mt-3">{t('privacy.section4.note')}</p>
              </div>

              {/* Section 5 */}
              <div className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">{t('privacy.section5.title')}</h2>
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('privacy.section5.content')}</p>
              </div>

              {/* Section 6 */}
              <div className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">{t('privacy.section6.title')}</h2>
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-3">{t('privacy.section6.content')}</p>
                <ul className="list-disc pl-6 space-y-2 text-gray-700 dark:text-gray-300">
                  {t('privacy.section6.items').map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mt-4">{t('privacy.section6.note')}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Privacy;